// src/styles/components/MuiStack.js
const MuiStack = {
  defaultProps: {
    useFlexGap: true,
  },
  styleOverrides: {
    root: {
      '&.MuiStack-root': {
        // Default spacing can be configured via the spacing prop
      },
    },
  },
};

export default MuiStack;